<template>
  <div class="md-layout">
    <md-dialog :md-active.sync="viewTourDialog">
      <md-dialog-title>Pick an Adventure</md-dialog-title>

      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(addTour)" class="mt-4">
          <div class="md-layout">
            <div class="md-layout-item md-size-100">
              <md-field>
                <label for="adventure">Adventure</label>
                <md-select v-model="selectedTour" name="tour" id="tour">
                  <md-option
                    v-for="tour in availableTours"
                    :key="tour.id"
                    :value="tour.id"
                  >
                    {{ tour.title }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
          </div>
          <md-dialog-actions>
            <md-button class="md-primary md-dense" @click="cancel"
              >Cancel</md-button
            >
            <md-button type="submit" class="md-primary md-dense">Add</md-button>
          </md-dialog-actions>
        </form>
      </ValidationObserver>
    </md-dialog>
  </div>
</template>

<script>
export default {
  name: "EnquiryTourDialog",

  props: {
    viewTourDialog: Boolean,
    availableTours: Array
  },

  data() {
    return {
      selectedTour: -1
    };
  },

  components: {},

  methods: {
    cancel() {
      this.$emit("cancel");
    },

    addTour() {
      this.$emit("add", this.selectedTour);
      this.selectedTour = -1;
    }
  }
};
</script>
